
export const REQUEST_FULL_WORKOUT = 'workout/REQUEST_FULL_WORKOUT';
